import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useState } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card.tsx'
import { Input } from '@/components/ui/input.tsx'
import { Label } from '@/components/ui/label.tsx'
import { Switch } from '@/components/ui/switch.tsx'
import { TaxTypeType } from './types.ts'

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  tax_type: TaxTypeType
  submitText: string
}

export default function Form({ tax_type, submitText, ...formProps }: FormProps) {
  const [active, setActive] = useState(Boolean(tax_type.active))

  return (
    <InertiaForm
      transform={data => ({ tax_type: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <Card className="border-border bg-card">
          <CardHeader>
            <CardTitle>Informations du type de taxe</CardTitle>
            <CardDescription>Définissez les détails et le statut du type de taxe.</CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="name">Nom</Label>
              <Input
                type="text"
                name="name"
                id="name"
                defaultValue={tax_type.name}
                placeholder="Nom du type de taxe"
              />
              {errors.name && (
                <p className="text-sm font-medium text-destructive">
                  {Array.isArray(errors.name) ? errors.name.join(', ') : errors.name}
                </p>
              )}
            </div>


            <div className="space-y-2">
              <Label htmlFor="active">Actif</Label>
              <input type="hidden" name="active" value={active ? '1' : '0'} />
              <div className="flex items-center gap-3">
                <Switch
                  id="active"
                  checked={active}
                  onCheckedChange={setActive}
                  aria-label="Basculer le statut actif"
                />
                <span className="text-sm text-muted-foreground">
                  {active ? 'Activé' : 'Désactivé'}
                </span>
              </div>
              {errors.active && (
                <p className="text-sm font-medium text-destructive">
                  {Array.isArray(errors.active) ? errors.active.join(', ') : errors.active}
                </p>
              )}
            </div>

            <div className="flex justify-end">
              <Button type="submit" disabled={processing}>
                {submitText}
              </Button>
            </div>
          </CardContent>
        </Card>
      )}
    </InertiaForm>
  )
}
